/**
 * Access-token expiry helpers (payload only; no signature verification).
 */

export const ACCESS_TOKEN_REFRESH_LEEWAY_SEC = 60;

function payloadFromJwt(accessToken: string): Record<string, unknown> | null {
  const parts = accessToken.split(".");
  if (parts.length < 2) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function accessTokenExpiresAtSec(accessToken: string | null): number | null {
  if (!accessToken) {
    return null;
  }
  const payload = payloadFromJwt(accessToken);
  const exp = payload?.exp;
  if (typeof exp === "number" && Number.isFinite(exp)) {
    return exp;
  }
  if (typeof exp === "string" && /^\d+$/.test(exp)) {
    return Number(exp);
  }
  return null;
}

/** True when the token is missing, expired, or within the refresh leeway window. */
export function shouldRefreshAccessToken(
  accessToken: string | null,
  nowSec = Math.floor(Date.now() / 1000),
): boolean {
  if (!accessToken) {
    return true;
  }
  const exp = accessTokenExpiresAtSec(accessToken);
  if (exp === null) {
    return false;
  }
  return nowSec >= exp - ACCESS_TOKEN_REFRESH_LEEWAY_SEC;
}
